$(document).ready(function(){
	init(); 
});


function init(){
	gsap.registerPlugin(ScrollTrigger);

	externalInits();
	animationFunctions();
	navigationFunctions();
	scrollFunctions();
	signupFormFunction();
	heroFunctions();
	contentBlockSliderFunctions();
	roomsSuitesFunctions();
	eventSpacesFunctions();
	faqFunctions();
	awardsPressFunctions();
	menuFunctions();
	ajaxFunctions();
	popupFunctions();
}
